import { render, staticRenderFns } from "./CreateCrewCast.vue?vue&type=template&id=52cb630d&v-on-clickaway=cancel&"
import script from "./CreateCrewCast.vue?vue&type=script&lang=ts&"
export * from "./CreateCrewCast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports